import React from "react";
import { Controller } from "react-hook-form";
import { Form } from "react-bootstrap";
import { ReactComponent as BuyButton } from "../../../../../assets/images/BuyButton.svg";
import { splitOptionSymbol } from "../../../../../utils/helpers";
import ExchangePill from "../../../../../components/ExchangePill";
import ValueChangeComponent from "../../../../../components/common/ValueChangeComponent";
import nextId from "react-id-generator";

// @hooks
import useLiveQuotesGeneric from "../../../../../hooks/socket/useLiveQuoteGeneric";

interface ReducedMarginCheckboxProps {
  control: any; // Adjust type based on your form control
  watch: any; // Adjust type based on your form watch function
  requitedToken?: number | null;
  symbolInfo?: number;
  onClick: () => void;
}

const ReducedMarginCheckbox: React.FC<ReducedMarginCheckboxProps> = ({
  control,
  watch,
  requitedToken,
  symbolInfo,
  onClick
}) => {
  const listenerReducedMargin = nextId();

  if (!symbolInfo) {
    return null;
  }

  const liveMarginData = useLiveQuotesGeneric(
    requitedToken ?? 0,
    symbolInfo ?? 0,
    listenerReducedMargin
  );

  const { index, month, optionType, strike, year } = splitOptionSymbol(
    liveMarginData?.short_name ?? ""
  );

  return (
    <div className="d-flex justify-content-between gap-3">
      <div className="d-flex gap-2">
        <div onClick={onClick}>
          <Controller
            name="isReducedMargin"
            control={control}
            render={({ field: { onChange } }) => (
              <Form.Check
                className="text-color isReducedMargin"
                onClick={onChange}
                type="checkbox"
                id="Reduce Margin"
                label="Reduce Margin"
                style={{
                  fontWeight: 500,
                  fontSize: 12,
                  lineHeight: "16px",
                }}
              />
            )}
          />
        </div>
        {watch("isReducedMargin") && (
          <>
            <div
            className="text-color"
              style={{
                fontWeight: 500,
                fontSize: 12,
                lineHeight: "16px",
              }}
            >
              <BuyButton style={{ height: 24, width: 24 }} />
              {index} {strike}
              <span style={{ fontWeight: 700 }}>
                <ExchangePill className="mx-1" text="CE" />
              </span>
            </div>

            {/* <div>{liveMarginData?.lp}</div> */}
            <ValueChangeComponent
              value={liveMarginData?.lp ?? 0}
              className="custom-class text-color"
              style={{ fontSize: 14 }}
            />
          </>
        )}
      </div>
      <div></div>
    </div>
  );
};

export default ReducedMarginCheckbox;
